import React, { createContext, useCallback, useContext, useState } from "react";
import { EnquiryModal } from "@/components/EnquiryModal";

const EnquiryContext = createContext({ openEnquiry: () => {} });

export function EnquiryProvider({ children }) {
  const [state, setState] = useState({ open: false, course: "" });
  const openEnquiry = useCallback((course = "") => setState({ open: true, course }), []);
  return (
    <EnquiryContext.Provider value={{ openEnquiry }}>
      {children}
      <EnquiryModal open={state.open} defaultCourse={state.course} onClose={() => setState({ open: false, course: "" })} />
    </EnquiryContext.Provider>
  );
}

export const useEnquiry = () => useContext(EnquiryContext);
